import type { QueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";

import { patchViewerContextQueryData } from "@/lib/viewer-context";
import { Cookies } from "@garimpa/lib/cookies";
import { serializeCookie } from "@garimpa/lib/serializeCookie";

interface UseBrowserTimeZoneOptions {
  queryClient: QueryClient;
  initialTimeZone: string;
}

export function useBrowserTimeZone({
  queryClient,
  initialTimeZone,
}: UseBrowserTimeZoneOptions): string {
  const [timeZone, setTimeZone] = useState(initialTimeZone);

  useEffect(() => {
    const browserZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (!browserZone || browserZone === timeZone) return;

    setTimeZone(browserZone);
    patchViewerContextQueryData(queryClient, { preferences: { timeZone: browserZone } });
    document.cookie = serializeCookie(Cookies.timezone, browserZone, {
      secure: window.location.protocol === "https:",
    });
  }, [queryClient, timeZone]);

  return timeZone;
}
